import { useEffect } from "react"
import { useSnackbar } from "../components/snackbar/snackbar"

export default (compileStatus) => {
    const { enqueueSnackbar } = useSnackbar()

    useEffect(() => {
        if (compileStatus === "broken") {
            enqueueSnackbar("Please fix the errors before running", {
                variant: "error",
            })
        }
    }, [compileStatus])
}